import gql from "graphql-tag";

export const IsnQcResultFragment = gql`
    fragment IsnQcResultFragment on IsnQcResult {
        isnStatus {
            shortLabel
        }
        allowed
        companyID
        quickCheckStatus
        trainingStatus
        errorMessage
        isnId
        firstName
        lastName
        companyName
        mostRecentTrainingQualificationExpirationName
        mostRecentTrainingExpirationDate
        assignedActivities
        dataAsOf
        reason
        reasonsForNonCompliance
        scCompanyGrade
        scCompanyGradeSince
        trainingDeficiencies
        trainingQualificationProject {
            id
            name
        }
        operatorQualificationProject {
            id
            name
        }
        onlineTrainingQualificationProject {
            id
            name
        }
    }
`

export const IsnResultWithHeaderFragment = gql`
    fragment IsnResultWithHeaderFragment on IsnResultWithHeader {
        success
        qc_count
        isn_customer
        isn_ownerid
        error_message
        quick_check_status
        reason
        qc_count
        qc_result {
            ...IsnQcResultFragment
        },
        selectedResult {
            ...IsnQcResultFragment
        }
    }
    ${IsnQcResultFragment}
`